import FuseUtils from '@fuse/utils/FuseUtils';
import History from '@history';
import { Button, Icon, useMediaQuery, useTheme } from '@material-ui/core';
import authRoles from 'app/auth/authRoles';
import { userRoleSelector } from 'app/auth/store/user.selector';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { writeViewModePreference } from '../viewMode';

export const MobileVersionButton = () => {
  const { t } = useTranslation('mobile');
  const theme = useTheme();
  const userRole = useSelector(userRoleSelector);
  const isBelowFullWidth = useMediaQuery(theme.breakpoints.down('md'));
  // A tablet of 1280 px or more in landscape (iPad Pro) must still be able to switch.
  const hasTouchPointer = useMediaQuery('(pointer: coarse)');

  // `/m` is guarded by authRoles.owner: any other role would be bounced back after the switch.
  if (!FuseUtils.hasPermission(authRoles.owner, userRole)) return null;
  if (!isBelowFullWidth && !hasTouchPointer) return null;

  return (
    <Button
      className="normal-case my-8 mr-8"
      variant="outlined"
      size="small"
      startIcon={<Icon>smartphone</Icon>}
      onClick={() => {
        writeViewModePreference('mobile');
        History.push(routesUrl.mobileHome);
      }}
    >
      {t('shell.mobileVersion')}
    </Button>
  );
};
